var selectedCategoryId = 0;
var initialVisibleNews = 9;
var loadMoreNews = 9;
var visibleNews = initialVisibleNews;
var categoryNews = $('.sub-news-list-page__item').length;

displayFeatureArticle(selectedCategoryId);
renderNewsList(categoryNews, initialVisibleNews, selectedCategoryId);

$('.select-category').on('click', function (e) {
    e.preventDefault();
    selectedCategoryId = $(this).data('category-id');

    // Set active class to category
    $('.select-category').removeClass('selected');
    $(this).addClass('selected');

    // Hide elements first when category selected
    $('.sub-news-list-featured-article').hide();
    $('.sub-news-list-page__item').hide();
    $('#showMore').hide();

    visibleNews = initialVisibleNews;
    displayFeatureArticle(selectedCategoryId);
    renderNewsList(categoryNews, visibleNews, selectedCategoryId)
});

$('#showMore').on('click', function (e) {
    visibleNews += loadMoreNews;
    renderNewsList(categoryNews, visibleNews, selectedCategoryId)
});

function renderNewsList(categoryNews, visibleNews, selectedCategoryId ) {

    var countCategoryNews = 0;

    $('.sub-news-list-page__item').each(function (index) {

        if (selectedCategoryId > 0) {

            var categoryIds = $(this).data('category-id').toString().split(',').map(Number);

            var isMatch = categoryIds.includes(selectedCategoryId)

            if (isMatch && (countCategoryNews < visibleNews)) {
                $(this).fadeIn();
            } else {
                $(this).fadeOut();
            }

            if (isMatch)
            { countCategoryNews++; }

        } else {
            if (countCategoryNews < visibleNews) {
                $(this).fadeIn();
            } else {
                $(this).fadeOut();
            }

            countCategoryNews++;
        }
    });

    $('.sub-news-list-page__item').promise().done(() => {
        shouldDisplayMoreNews(countCategoryNews, visibleNews);
    })
}

function shouldDisplayMoreNews(countCategoryNews, visibleNews) {

    if (countCategoryNews > visibleNews) {
        $('#showMore').show();
    } else {
        $('#showMore').hide();
    }
}

function displayFeatureArticle(selectedCategoryId) {
    if (selectedCategoryId === 0) {
        $('.sub-news-list-featured-article').fadeIn();
    } else {
        $('.sub-news-list-featured-article').fadeOut();
    }
}